module.exports = __webpack_public_path__ + "img/bg_avatar_female_28.89983cf6.png";